import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';

const grw1672DisplayTargetedJsmTemplateCtaInNav4RelayProvider = {
	get(): boolean {
		const [config] = UNSAFE_noExposureExp('grw-1672_display_targeted_jsm_template_cta_in_nav4');
		const cohort = config.get('cohort', 'not-enrolled');
		return cohort === 'variation' || cohort === 'control';
	},
};

export default grw1672DisplayTargetedJsmTemplateCtaInNav4RelayProvider;
